import { Tooltip } from "bootstrap";

const tooltipOptions = new WeakMap();

function normalizeTriggers(triggers) {
    if (Array.isArray(triggers)) {
        return triggers.join(" ");
    }

    return typeof triggers === "string" && triggers !== "" ? triggers : "hover focus";
}

function normalizeDelay(delay) {
    if (typeof delay === "number") {
        return {
            show: delay,
            hide: delay,
        };
    }

    if (delay && typeof delay === "object") {
        return {
            show: Number.isFinite(delay.show) ? delay.show : 0,
            hide: Number.isFinite(delay.hide) ? delay.hide : 0,
        };
    }

    return {
        show: 0,
        hide: 0,
    };
}

function normalizeTooltipOptions(binding) {
    const rawValue = binding.value;

    if (rawValue === undefined || rawValue === null || rawValue === false) {
        return null;
    }

    const value = typeof rawValue === "string" ? { content: rawValue } : rawValue;
    const content = typeof value.content === "function" ? value.content() : value.content;

    if (content === undefined || content === null || content === false || content === "") {
        return null;
    }

    const placementModifier = Object.keys(binding.modifiers || {}).find((modifier) => binding.modifiers[modifier] === true);

    return {
        // Vue can update or unmount the target during Bootstrap's fade callbacks.
        animation: false,
        container: "body",
        customClass: value.popperClass || "",
        delay: normalizeDelay(value.delay),
        html: Boolean(value.html),
        offset: [0, 0],
        placement: value.placement || placementModifier || "top",
        title: content,
        trigger: normalizeTriggers(value.triggers),
    };
}

function disposeTooltip(el) {
    Tooltip.getInstance(el)?.dispose();
    tooltipOptions.delete(el);
    el.removeAttribute("title");
    el.removeAttribute("data-bs-original-title");
}

function hasSameConfiguration(previous, next) {
    return (
        previous &&
        previous.customClass === next.customClass &&
        previous.delay.show === next.delay.show &&
        previous.delay.hide === next.delay.hide &&
        previous.html === next.html &&
        previous.placement === next.placement &&
        previous.trigger === next.trigger
    );
}

function applyTooltipOptions(el, options) {
    if (!options) {
        disposeTooltip(el);
        return;
    }

    const instance = Tooltip.getInstance(el);
    const previous = tooltipOptions.get(el);

    if (instance && hasSameConfiguration(previous, options)) {
        if (previous.title !== options.title) {
            instance.setContent({ ".tooltip-inner": options.title });
        }
    } else {
        disposeTooltip(el);
        new Tooltip(el, options);
    }

    tooltipOptions.set(el, options);
}

const TooltipDirective = {
    mounted(el, binding) {
        applyTooltipOptions(el, normalizeTooltipOptions(binding));
    },
    updated(el, binding) {
        applyTooltipOptions(el, normalizeTooltipOptions(binding));
    },
    unmounted(el) {
        applyTooltipOptions(el, null);
    },
};

export default {
    install(app) {
        app.directive("tooltip", TooltipDirective);
    },
};
